import React from 'react'

import { getOptionValue } from '../form/picker/_helpers'
import DeletedTag from '../../../../components/helpers/DeletedTag'
import LabelListItem from './LabelListItem'
import Marker from '../shapes/Marker'

const SelectableListItem = ({
  icon,
  rightIcon,
  iconSize,
  iconColor,
  t,
  option,
  isSelected,
  isCurrent,
  multiple,
  labelField,
  descriptionField,
  ...props
}) => {
  let bgColor = 'white'
  if (isSelected) bgColor = 'light2'
  if (isCurrent) bgColor = 'light3'

  return (
    <LabelListItem
      label={t(getOptionValue(option, labelField))}
      description={getOptionValue(option, descriptionField, true)}
      color={isSelected ? 'primary' : 'dark1'}
      bgColor={bgColor}
      hoverBgColor="light1"
      gap={0.5}
      paddingH={0.5}
      leftContent={<Marker value={isSelected} circle={!multiple} />}
      rightContent={<DeletedTag entity={option} />}
      {...props}
    />
  )
}

export default SelectableListItem
